__turbopack_context__.v({
  "disabled": "uhrW2W_disabled",
  "enabled": "uhrW2W_enabled",
  "iconWrapper": "uhrW2W_iconWrapper",
  "panelContent": "uhrW2W_panelContent",
  "panelHeader": "uhrW2W_panelHeader",
  "panelTitle": "uhrW2W_panelTitle",
  "wrapper": "uhrW2W_wrapper",
});
